//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets issue by ID
 */
export function getIssue(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.IssueDto> {
    let url_ = getBaseUrl() + "/api/issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetIssue,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetIssue(_response);
    });
}

function processGetIssue(response: AxiosResponse): Promise<Types.IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.IssueDto.fromJS(resultData200);
        return Promise.resolve<Types.IssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.IssueDto>(null as any);
}

/**
 * Remove issue by ID
 */
export function removeIssue(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveIssue,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveIssue(_response);
    });
}

function processRemoveIssue(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Update existed issue
 * @param subject (optional) 
 * @param topic (optional) 
 * @param topicAdditional (optional) 
 * @param description (optional) 
 * @param resultId (optional) 
 * @param fieldId (optional) 
 * @param stepName (optional) 
 * @param fieldDescription (optional) 
 * @param deadlineAt (optional) 
 * @param linkedPatientUniqId (optional) 
 * @param newFiles (optional) 
 * @param filesToDelete (optional) 
 * @param recommendedAction (optional) 
 */
export function patchIssue(id: number, subject?: string | null | undefined, topic?: string | null | undefined, topicAdditional?: string | null | undefined, description?: string | null | undefined, resultId?: number | null | undefined, fieldId?: string | null | undefined, stepName?: string | null | undefined, fieldDescription?: string | null | undefined, deadlineAt?: Date | undefined, linkedPatientUniqId?: string | null | undefined, newFiles?: Types.FileParameter[] | null | undefined, filesToDelete?: string[] | null | undefined, recommendedAction?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.IssueDto> {
    let url_ = getBaseUrl() + "/api/issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (subject !== null && subject !== undefined)
        content_.append("Subject", subject.toString());
    if (topic !== null && topic !== undefined)
        content_.append("Topic", topic.toString());
    if (topicAdditional !== null && topicAdditional !== undefined)
        content_.append("TopicAdditional", topicAdditional.toString());
    if (description !== null && description !== undefined)
        content_.append("Description", description.toString());
    if (resultId !== null && resultId !== undefined)
        content_.append("ResultId", resultId.toString());
    if (fieldId !== null && fieldId !== undefined)
        content_.append("FieldId", fieldId.toString());
    if (stepName !== null && stepName !== undefined)
        content_.append("StepName", stepName.toString());
    if (fieldDescription !== null && fieldDescription !== undefined)
        content_.append("FieldDescription", fieldDescription.toString());
    if (deadlineAt === null || deadlineAt === undefined)
        throw new Error("The parameter 'deadlineAt' cannot be null.");
    else
          content_.append("DeadlineAt", Types.formatDate(deadlineAt));
    if (linkedPatientUniqId !== null && linkedPatientUniqId !== undefined)
        content_.append("LinkedPatientUniqId", linkedPatientUniqId.toString());
    if (newFiles !== null && newFiles !== undefined)
        newFiles.forEach(item_ => content_.append("NewFiles", item_.data, item_.fileName ? item_.fileName : "NewFiles") );
    if (filesToDelete !== null && filesToDelete !== undefined)
        filesToDelete.forEach(item_ => content_.append("FilesToDelete", item_.toString()));
    if (recommendedAction === null || recommendedAction === undefined)
        throw new Error("The parameter 'recommendedAction' cannot be null.");
    else
        content_.append("RecommendedAction", recommendedAction.toString());

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchIssue,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchIssue(_response);
    });
}

function processPatchIssue(response: AxiosResponse): Promise<Types.IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.IssueDto.fromJS(resultData200);
        return Promise.resolve<Types.IssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.IssueDto>(null as any);
}

/**
 * Gets all issues for study
 * @param patientUniqId (optional) Filter issues by the patient unique Id
 * @param patientUniqIds (optional) Filter issues by the patient unique Id
 * @param state (optional) Filter issues by state
 * @param subjectList (optional) Filter issues by subject
 * @param patientGroupIds (optional) Filter issues by linked patient group
 * @param isNew (optional) Filter issues by IsNew field
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getIssuesForStudy(studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfIssueDto> {
    let url_ = getBaseUrl() + "/api/issues/forStudy?";
      if (studyId === undefined || studyId === null)
        throw new Error("The parameter 'studyId' must be defined and cannot be null.");
      else
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (patientUniqId !== undefined && patientUniqId !== null)
        url_ += "PatientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
    if (patientUniqIds !== undefined && patientUniqIds !== null)
        patientUniqIds && patientUniqIds.forEach(item => { url_ += "PatientUniqIds=" + encodeURIComponent("" + item) + "&"; });
    if (state !== undefined && state !== null)
        url_ += "State=" + encodeURIComponent("" + state) + "&";
    if (subjectList !== undefined && subjectList !== null)
        subjectList && subjectList.forEach(item => { url_ += "SubjectList=" + encodeURIComponent("" + item) + "&"; });
    if (patientGroupIds !== undefined && patientGroupIds !== null)
        patientGroupIds && patientGroupIds.forEach(item => { url_ += "PatientGroupIds=" + encodeURIComponent("" + item) + "&"; });
    if (isNew !== undefined && isNew !== null)
        url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetIssuesForStudy,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetIssuesForStudy(_response);
    });
}

function processGetIssuesForStudy(response: AxiosResponse): Promise<Types.PagedResultOfIssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PagedResultOfIssueDto.fromJS(resultData200);
        return Promise.resolve<Types.PagedResultOfIssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfIssueDto>(null as any);
}

/**
 * Gets issues grouped by patients
 * @param patientUniqId (optional) Filter issues by the patient unique Id
 * @param patientUniqIds (optional) Filter issues by the patient unique Id
 * @param state (optional) Filter issues by state
 * @param subjectList (optional) Filter issues by subject
 * @param patientGroupIds (optional) Filter issues by linked patient group
 * @param isNew (optional) Filter issues by IsNew field
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getIssuesGroupedByPatients(studyId: number, patientUniqId?: string | null | undefined, patientUniqIds?: string[] | null | undefined, state?: Types.IssuesStateEnum | null | undefined, subjectList?: string[] | null | undefined, patientGroupIds?: number[] | null | undefined, isNew?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfGroupedIssueDto> {
    let url_ = getBaseUrl() + "/api/issues/groupedByPatients?";
      if (studyId === undefined || studyId === null)
        throw new Error("The parameter 'studyId' must be defined and cannot be null.");
      else
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
    if (patientUniqId !== undefined && patientUniqId !== null)
        url_ += "PatientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
    if (patientUniqIds !== undefined && patientUniqIds !== null)
        patientUniqIds && patientUniqIds.forEach(item => { url_ += "PatientUniqIds=" + encodeURIComponent("" + item) + "&"; });
    if (state !== undefined && state !== null)
        url_ += "State=" + encodeURIComponent("" + state) + "&";
    if (subjectList !== undefined && subjectList !== null)
        subjectList && subjectList.forEach(item => { url_ += "SubjectList=" + encodeURIComponent("" + item) + "&"; });
    if (patientGroupIds !== undefined && patientGroupIds !== null)
        patientGroupIds && patientGroupIds.forEach(item => { url_ += "PatientGroupIds=" + encodeURIComponent("" + item) + "&"; });
    if (isNew !== undefined && isNew !== null)
        url_ += "IsNew=" + encodeURIComponent("" + isNew) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetIssuesGroupedByPatients,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetIssuesGroupedByPatients(_response);
    });
}

function processGetIssuesGroupedByPatients(response: AxiosResponse): Promise<Types.PagedResultOfGroupedIssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PagedResultOfGroupedIssueDto.fromJS(resultData200);
        return Promise.resolve<Types.PagedResultOfGroupedIssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfGroupedIssueDto>(null as any);
}

/**
 * Create new issue
 * @param subject (optional) 
 * @param topic (optional) 
 * @param topicAdditional (optional) 
 * @param description (optional) 
 * @param resultId (optional) 
 * @param fieldId (optional) 
 * @param stepName (optional) 
 * @param fieldDescription (optional) 
 * @param deadlineAt (optional) 
 * @param linkedPatientUniqId (optional) 
 * @param files (optional) 
 * @param recommendedAction (optional) 
 */
export function addIssue(studyId: number, subject?: string | undefined, topic?: string | undefined, topicAdditional?: string | null | undefined, description?: string | undefined, resultId?: number | null | undefined, fieldId?: string | null | undefined, stepName?: string | null | undefined, fieldDescription?: string | null | undefined, deadlineAt?: Date | undefined, linkedPatientUniqId?: string | null | undefined, files?: Types.FileParameter[] | null | undefined, recommendedAction?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.IssueDto> {
    let url_ = getBaseUrl() + "/api/issues?";
      if (studyId === undefined || studyId === null)
        throw new Error("The parameter 'studyId' must be defined and cannot be null.");
      else
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (subject === null || subject === undefined)
        throw new Error("The parameter 'subject' cannot be null.");
    else
        content_.append("Subject", subject.toString());
    if (topic === null || topic === undefined)
        throw new Error("The parameter 'topic' cannot be null.");
    else
        content_.append("Topic", topic.toString());
    if (topicAdditional !== null && topicAdditional !== undefined)
        content_.append("TopicAdditional", topicAdditional.toString());
    if (description === null || description === undefined)
        throw new Error("The parameter 'description' cannot be null.");
    else
        content_.append("Description", description.toString());
    if (resultId !== null && resultId !== undefined)
        content_.append("ResultId", resultId.toString());
    if (fieldId !== null && fieldId !== undefined)
        content_.append("FieldId", fieldId.toString());
    if (stepName !== null && stepName !== undefined)
        content_.append("StepName", stepName.toString());
    if (fieldDescription !== null && fieldDescription !== undefined)
        content_.append("FieldDescription", fieldDescription.toString());
    if (deadlineAt === null || deadlineAt === undefined)
        throw new Error("The parameter 'deadlineAt' cannot be null.");
    else
          content_.append("DeadlineAt", Types.formatDate(deadlineAt));
    if (linkedPatientUniqId !== null && linkedPatientUniqId !== undefined)
        content_.append("LinkedPatientUniqId", linkedPatientUniqId.toString());
    if (files !== null && files !== undefined)
        files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
    if (recommendedAction === null || recommendedAction === undefined)
        throw new Error("The parameter 'recommendedAction' cannot be null.");
    else
        content_.append("RecommendedAction", recommendedAction.toString());

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddIssue,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddIssue(_response);
    });
}

function processAddIssue(response: AxiosResponse): Promise<Types.IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.IssueDto.fromJS(resultData200);
        return Promise.resolve<Types.IssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.IssueDto>(null as any);
}

/**
 * Perform issue operation
 */
export function performIssueOperation(id: number, dto: Types.PerformIssueOperationDto, config?: AxiosRequestConfig | undefined): Promise<Types.IssueDto> {
    let url_ = getBaseUrl() + "/api/issues/{id}/performOperation";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPerformIssueOperation,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPerformIssueOperation(_response);
    });
}

function processPerformIssueOperation(response: AxiosResponse): Promise<Types.IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.IssueDto.fromJS(resultData200);
        return Promise.resolve<Types.IssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.IssueDto>(null as any);
}

/**
 * Remove issue operation
 */
export function removeIssueOperation(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/issues/operation/{id}/revert";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveIssueOperation,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveIssueOperation(_response);
    });
}

function processRemoveIssueOperation(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Change issue operation state
 * @param rejectComment (optional) 
 */
export function resumeIssueOperation(id: number, newState: Types.IssueOperationStateEnum, rejectComment?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.IssueOperationDto> {
    let url_ = getBaseUrl() + "/api/issues/operation/{id}/resume?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (newState === undefined || newState === null)
        throw new Error("The parameter 'newState' must be defined and cannot be null.");
      else
        url_ += "newState=" + encodeURIComponent("" + newState) + "&";
    if (rejectComment !== undefined && rejectComment !== null)
        url_ += "rejectComment=" + encodeURIComponent("" + rejectComment) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigResumeIssueOperation,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResumeIssueOperation(_response);
    });
}

function processResumeIssueOperation(response: AxiosResponse): Promise<Types.IssueOperationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.IssueOperationDto.fromJS(resultData200);
        return Promise.resolve<Types.IssueOperationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.IssueOperationDto>(null as any);
}

/**
 * Check the issue
 */
export function checkIssue(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/issues/{id}/check";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCheckIssue,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCheckIssue(_response);
    });
}

function processCheckIssue(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get issue history by Id
 */
export function getIssueHistory(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.IssueHistoryDto> {
    let url_ = getBaseUrl() + "/api/issues/{id}/history";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetIssueHistory,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetIssueHistory(_response);
    });
}

function processGetIssueHistory(response: AxiosResponse): Promise<Types.IssueHistoryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.IssueHistoryDto.fromJS(resultData200);
        return Promise.resolve<Types.IssueHistoryDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.IssueHistoryDto>(null as any);
}

/**
 * Get issue comments
 */
export function getIssueComments(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.IssueCommentDto[]> {
    let url_ = getBaseUrl() + "/api/issues/{id}/comments";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetIssueComments,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetIssueComments(_response);
    });
}

function processGetIssueComments(response: AxiosResponse): Promise<Types.IssueCommentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.IssueCommentDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.IssueCommentDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.IssueCommentDto[]>(null as any);
}

/**
 * Add comment to the issue
 */
export function addIssueComment(id: number, message: string, config?: AxiosRequestConfig | undefined): Promise<Types.IssueCommentDto> {
    let url_ = getBaseUrl() + "/api/issues/{id}/comment?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      if (message === undefined || message === null)
        throw new Error("The parameter 'message' must be defined and cannot be null.");
      else
        url_ += "message=" + encodeURIComponent("" + message) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddIssueComment,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddIssueComment(_response);
    });
}

function processAddIssueComment(response: AxiosResponse): Promise<Types.IssueCommentDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.IssueCommentDto.fromJS(resultData200);
        return Promise.resolve<Types.IssueCommentDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.IssueCommentDto>(null as any);
}

/**
 * Remove issue comment
 */
export function removeIssueComment(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/issues/comments/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveIssueComment,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveIssueComment(_response);
    });
}

function processRemoveIssueComment(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetIssue: Partial<AxiosRequestConfig> | null;
export function getGetIssueRequestConfig() {
  return _requestConfigGetIssue;
}
export function setGetIssueRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetIssue = value;
}
export function patchGetIssueRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetIssue = patch(_requestConfigGetIssue ?? {});
}

let _requestConfigRemoveIssue: Partial<AxiosRequestConfig> | null;
export function getRemoveIssueRequestConfig() {
  return _requestConfigRemoveIssue;
}
export function setRemoveIssueRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveIssue = value;
}
export function patchRemoveIssueRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveIssue = patch(_requestConfigRemoveIssue ?? {});
}

let _requestConfigPatchIssue: Partial<AxiosRequestConfig> | null;
export function getPatchIssueRequestConfig() {
  return _requestConfigPatchIssue;
}
export function setPatchIssueRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchIssue = value;
}
export function patchPatchIssueRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchIssue = patch(_requestConfigPatchIssue ?? {});
}

let _requestConfigGetIssuesForStudy: Partial<AxiosRequestConfig> | null;
export function getGetIssuesForStudyRequestConfig() {
  return _requestConfigGetIssuesForStudy;
}
export function setGetIssuesForStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetIssuesForStudy = value;
}
export function patchGetIssuesForStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetIssuesForStudy = patch(_requestConfigGetIssuesForStudy ?? {});
}

let _requestConfigGetIssuesGroupedByPatients: Partial<AxiosRequestConfig> | null;
export function getGetIssuesGroupedByPatientsRequestConfig() {
  return _requestConfigGetIssuesGroupedByPatients;
}
export function setGetIssuesGroupedByPatientsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetIssuesGroupedByPatients = value;
}
export function patchGetIssuesGroupedByPatientsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetIssuesGroupedByPatients = patch(_requestConfigGetIssuesGroupedByPatients ?? {});
}

let _requestConfigAddIssue: Partial<AxiosRequestConfig> | null;
export function getAddIssueRequestConfig() {
  return _requestConfigAddIssue;
}
export function setAddIssueRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddIssue = value;
}
export function patchAddIssueRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddIssue = patch(_requestConfigAddIssue ?? {});
}

let _requestConfigPerformIssueOperation: Partial<AxiosRequestConfig> | null;
export function getPerformIssueOperationRequestConfig() {
  return _requestConfigPerformIssueOperation;
}
export function setPerformIssueOperationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPerformIssueOperation = value;
}
export function patchPerformIssueOperationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPerformIssueOperation = patch(_requestConfigPerformIssueOperation ?? {});
}

let _requestConfigRemoveIssueOperation: Partial<AxiosRequestConfig> | null;
export function getRemoveIssueOperationRequestConfig() {
  return _requestConfigRemoveIssueOperation;
}
export function setRemoveIssueOperationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveIssueOperation = value;
}
export function patchRemoveIssueOperationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveIssueOperation = patch(_requestConfigRemoveIssueOperation ?? {});
}

let _requestConfigResumeIssueOperation: Partial<AxiosRequestConfig> | null;
export function getResumeIssueOperationRequestConfig() {
  return _requestConfigResumeIssueOperation;
}
export function setResumeIssueOperationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResumeIssueOperation = value;
}
export function patchResumeIssueOperationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResumeIssueOperation = patch(_requestConfigResumeIssueOperation ?? {});
}

let _requestConfigCheckIssue: Partial<AxiosRequestConfig> | null;
export function getCheckIssueRequestConfig() {
  return _requestConfigCheckIssue;
}
export function setCheckIssueRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCheckIssue = value;
}
export function patchCheckIssueRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCheckIssue = patch(_requestConfigCheckIssue ?? {});
}

let _requestConfigGetIssueHistory: Partial<AxiosRequestConfig> | null;
export function getGetIssueHistoryRequestConfig() {
  return _requestConfigGetIssueHistory;
}
export function setGetIssueHistoryRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetIssueHistory = value;
}
export function patchGetIssueHistoryRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetIssueHistory = patch(_requestConfigGetIssueHistory ?? {});
}

let _requestConfigGetIssueComments: Partial<AxiosRequestConfig> | null;
export function getGetIssueCommentsRequestConfig() {
  return _requestConfigGetIssueComments;
}
export function setGetIssueCommentsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetIssueComments = value;
}
export function patchGetIssueCommentsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetIssueComments = patch(_requestConfigGetIssueComments ?? {});
}

let _requestConfigAddIssueComment: Partial<AxiosRequestConfig> | null;
export function getAddIssueCommentRequestConfig() {
  return _requestConfigAddIssueComment;
}
export function setAddIssueCommentRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddIssueComment = value;
}
export function patchAddIssueCommentRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddIssueComment = patch(_requestConfigAddIssueComment ?? {});
}

let _requestConfigRemoveIssueComment: Partial<AxiosRequestConfig> | null;
export function getRemoveIssueCommentRequestConfig() {
  return _requestConfigRemoveIssueComment;
}
export function setRemoveIssueCommentRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveIssueComment = value;
}
export function patchRemoveIssueCommentRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveIssueComment = patch(_requestConfigRemoveIssueComment ?? {});
}